import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const legacyLogin = async (email, password) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/legacy`, {
        email,
        password
      }, {
        withCredentials: true
      });
      
      if (response.status === 200) {
        // Store JWT token and update auth state
        if (response.data.jwt_token) {
          login(response.data.email, response.data.jwt_token, response.data.TTL, response.data.access_level);
        }
        
        // Navigate to homepage on success
        navigate('/');
      }
    } catch (error) {
      console.error('Legacy login error:', error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Reset error state
    setError('');
    
    // Validate form
    if (!email || !password) {
      setError('請輸入電子郵件和密碼');
      return;
    }
    
    try {
      setLoading(true);
      
      // Call legacyLogin function
      await legacyLogin(email, password);
      
    } catch (err) {
      console.error('Login error:', err);
      setError('登入失敗，請檢查電子郵件和密碼');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // For mobile devices, redirect in the same window
    window.location.href = `${process.env.REACT_APP_API_BASE_URL}/api/auth/google`;
  };
  
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">Welcome Back!</h1>
          {/* <p className="login-subtitle">歡迎回來！請登入您的帳戶</p> */}
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            {/* <label htmlFor="email">電子郵件</label> */}
            <input
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="請輸入您的電子郵件"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            {/* <label htmlFor="password">密碼</label> */}
            <input
              type="password"
              id="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="請輸入您的密碼"
              disabled={loading}
            />
          </div>
          
          {/* <div className="remember-forgot">
            <div className="remember-me">
              <input type="checkbox" id="remember" />
              <label htmlFor="remember">記住我</label>
            </div>
            <a href="#" className="forgot-password">忘記密碼?</a>
          </div> */}
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? '登入中...' : '登入'}
          </button>
        </form>
        
        <div className="divider">
        </div>

        <div className="login-footer">
          <p>還沒有帳戶? <a href="/register" className="register" >立即註冊</a></p>
        </div>

        {/* <div className="divider">
          <span>OR</span>
        </div>

        <div className="social-login">
          <button 
            className="google-login-button" 
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            <svg className="google-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
              <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
              <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
              <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
            </svg>
            Continue with Google
          </button>
        </div> */}

      </div>
    </div>
  );
};

export default Login; 